import React from "react";
import { useTranslation } from "react-i18next";

import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from '@mui/material/Typography';
import {COLORS} from 'config/constants';

import {PACKAGE_FORM} from "../add_form/helpers";

import Guide from "./components/guide";
import DeclarationExamples from "./components/declarations-examples";
import AIAssistant from "./components/ai-assistant";

import './help_tabs.scss'

const tabLabelSx = {
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '24px',
  letterSpacing: '1px',
};

const HelpTabs = ({handleApplyCode, handleOpenModalCode, isExpandedGuideTab, isExpandedDeclarationTab, code}: HelpTabsProps) => {

  const { t } = useTranslation()

  const [ tabValue, setTabValue ] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => setTabValue(newValue);

  return <div className={`add-product__${PACKAGE_FORM.HELP_TABS} help-tabs`}>
    <Tabs variant='scrollable' scrollButtons='auto' value={tabValue} onChange={handleChange} sx={{
      '.MuiTab-root': {
        minHeight: '42px',
        padding: '9px 16px',
      },
      '& .MuiTabs-indicator': {
        zIndex: 1,
      },
      '&.MuiTabs-root': {
        minHeight: '42px',
        '&::after': {
          content: '""',
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          height: '1px',
          border: 0,
          backgroundColor: COLORS.SLIGHTLY_GRAY,
          pointerEvents: 'none',
          zIndex: 0,
        },
      },
    }}>
      <Tab id='help-tab-guide' aria-controls='help-panel-guide' label={<Typography variant='button' sx={tabLabelSx}>{t('common__text__guide')}</Typography>} />
      <Tab id='help-tab-declarations' aria-controls='help-panel-declarations' label={<Typography variant='button' sx={tabLabelSx}>{t('calc__text__packaging__examplesOfDeclarations')}</Typography>} />
      <Tab id='help-tab-assistant' aria-controls='help-panel-assistant' label={<Typography variant='button' sx={tabLabelSx}>{t('calc__text__packaging__AIAssistant')}</Typography>} />
    </Tabs>
    <div>
      {tabValue === 0 && <div
        role='tabpanel'
        id='help-panel-guide'
        aria-labelledby='help-tab-guide'
        className='help-tabs__tab'
      >
        <Guide handleApplyCode={handleApplyCode} isExpandedGuideTab={isExpandedGuideTab} />
      </div>}
      {tabValue === 1 && <div
        role='tabpanel'
        id='help-panel-declarations'
        aria-labelledby='help-tab-declarations'
        className='help-tabs__tab'
      >
        <DeclarationExamples
          handleApplyCode={handleApplyCode}
          isExpandedDeclarationTab={isExpandedDeclarationTab}
          code={code}
        />
      </div>}
      {tabValue === 2 && <div
        role='tabpanel'
        id='help-panel-assistant'
        aria-labelledby='help-tab-assistant'
        className='help-tabs__tab'
      >
        <AIAssistant handleApplyCode={handleOpenModalCode} isActive={tabValue === 2}/>
      </div>}
    </div>
  </div>
}

export default HelpTabs
